import React, { useEffect } from 'react';
import { InternationalizationContext } from '../../../Utils/Contexts';
import { getLabelTranslation } from './Utils';
import MultipleOptions from './MultipleOptions';
import { loadStateSession } from '../../FlyfishComponents/flyfishutils/utils';
interface Props {
	data: any;
	index?: number;
	voiceResponse: boolean;
	hideMenu?: Function;
	isUser?: boolean;
	channel?: string;
	botMessage?: string;
	handleSubmit?: Function;
	timeStamp?: string;
	addUserResponse?: Function;
	shouldDisableActions?: boolean;
	type?: string;
	dataV: any;
}
const SuggestionChips = (props: Props) => {
	const { data, voiceResponse, handleSubmit, addUserResponse } = props;
	let isUser = props.isUser ? props.isUser : false;
	useEffect(() => {
		const keyDownHandler = (event) => {
			if (
				event.key === 'Enter' &&
				props.channel === 'whatsapp' &&
				!props.shouldDisableActions
			) {
				event.preventDefault();
				const userResponse = loadStateSession('userResp');
				let deliverQuicklinks =
					props.type === 'quicklinks'
						? data.filter(
								(eachDisamb: any, index: number) =>
									index === Number(userResponse) - 1
						  )
						: data.filter(
								(eachDisamb: any, index: number) =>
									index === Number(userResponse) - 1
						  );
				if (
					deliverQuicklinks &&
					deliverQuicklinks[0] &&
					!props.shouldDisableActions
				) {
					addUserResponse(userResponse.toString(), Date.now());
					handleSubmit(
						deliverQuicklinks[0].type === 'QUICKLINK'
							? deliverQuicklinks[0].displayText.toString() ||
									deliverQuicklinks[0].actionText.toString()
							: deliverQuicklinks[0].linkValue.toString() ||
									deliverQuicklinks[0].displayText.toString() ||
									deliverQuicklinks[0].actionText.toString(),
						{},
						{ isHidden: true }
					);
				}
			}
		};
		document.addEventListener('keydown', keyDownHandler);
		return () => {
			document.removeEventListener('keydown', keyDownHandler);
		};
	}, [data, !props.shouldDisableActions]);

	return props.channel === 'whatsapp' ? (
		data && data.length > 0 ? (
			<>
				<div className='whatsapp-quicklink-disamb-wrapper'>
					<p className='whatsApp-text'>{props.botMessage}</p>
					{data.map((eachDisamb, index) => {
						return (
							<p className='whatsapp-quicklinks whatsApp-text' key={index}>
								{index + 1}.{' '}
								{eachDisamb.linkText ||
									eachDisamb.displayText ||
									eachDisamb.actionLabel}
							</p>
						);
					})}
					{data && data.length > 0 && (
						<p className='quicklinks-footer whatsApp-text'>
							<span>Tip:</span> To select an option,can enter its option number.
							E.g. 1
						</p>
					)}
				</div>
				<p className='whatsApp-time' style={{ margin: '0' }}>
					{props.timeStamp}
				</p>
			</>
		) : null
	) : (
		data &&
			data.map((eachDisamb, index) => {
				const onSubmit = (data1) => {
					props.hideMenu && props.hideMenu();
					window['autosubmit'](
						getLabelTranslation(
							eachDisamb,
							data1.currentLanguage,
							eachDisamb.actionValue
								? 'actionValue'
								: eachDisamb.actionText
								? 'actionText'
								: 'linkValue'
						)
					);
				};
				return (
					<InternationalizationContext.Consumer key={index}>
						{(val) => (
							<MultipleOptions
								index={props.index}
								key={index}
								isUser={isUser}
								handleSubmit={() => onSubmit(val)}
								voiceResponse={voiceResponse}
								eachOption={getLabelTranslation(
									eachDisamb,
									val.currentLanguage,
									eachDisamb.displayText
										? 'displayText'
										: eachDisamb.actionLabel
										? 'actionLabel'
										: eachDisamb.actionValue
										? 'actionValue'
										: 'linkText'
								)}
								data={props.dataV}
								configData={props.dataV}
							/>
						)}
					</InternationalizationContext.Consumer>
				);
			})
	);
};

export default SuggestionChips;
